import { createSlice } from '@reduxjs/toolkit'

export interface UserState {
    isLoading: boolean,
    data: object,
}

const initialState: UserState = {
    isLoading: true,
    data: null,
}

export const userOrganizationSlice = createSlice({
    name: 'user_organizations',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        setUserOrganization: (state, action) => {
            state.data = action.payload
            state.isLoading = false
        }
    },
})

// Action creators are generated for each case reducer function
export const { startLoading, setUserOrganization } = userOrganizationSlice.actions
